<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">


    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row bg-secondary p-2">
        <div class="col-lg-12 bg-white" style="border-radius: 1vw">
          <br>
          <h2 style="font-size: 1.6vw !important;">تعریف واحد سنجش</h2>

          <div class="p-2 d-flex align-items-center justify-content-center">
            <input v-model="name" type="text" class="form-control" style="width: 20vw;" placeholder="نام واحد سنجش">
            <button @click.prevent="store" class="btn btn-submit-1 btn-primary mx-2  ">
              <span v-if="!id">افزودن</span>
              <span v-else>ویرایش</span>
            </button>
              <span v-if="id" @click="resetItem">❌</span>
          </div>

          <hr>
          <br>
          <center v-show="!all_items.length">
            موردی یافت نشد!
          </center>
          <table v-show="all_items.length" class="table table-striped">
            <thead>
            <tr>
              <th style="width: 1vw;">ردیف</th>
              <th>نام واحد سنجش</th>
              <th style="width: 4vw;"> عملیات </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in all_items">
              <td scope="row">{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>
               <div class="d-flex" style="height: 1vw !important;">
                 <p style="width: 2vw;" @click.prevent="deleteMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </p>
                 <a  style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
               </div>
              </td>



            </tr>

            </tbody>
          </table>

        </div>
  </div>
  </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete">تایید</button>
      </div>
    </div>
  </div>
</template>
<script >
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export  default {
  components: {Splash, Sidebar},
  data(){
   return{
     all_items:[],
     name: '',
     id: '',
     id_delete: '',
     deleteModal: false,
   }
  },
  methods:{
    resetItem(){
      this.name = ''
      this.id  = ''
    },
    store(){
      if (!this.name){
        toast.error('نام واحد سنجش اجباری است!')
        return false;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name',this.name)
      if (this.id){
      formdata.append('id',this.id)

      }


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/units/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.message){
              toast.success(response.message)
              this.name = ''
              this.id  = ''
              this.all()
            }

          })
          .catch();
    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name',this.name)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/units/all_self`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.all){
               this.all_items.length=0
              response.all.forEach((ele)=>{
                this.all_items.push(ele)
              })
            }

          })
          .catch();
    },
    edit(id){
      this.id = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name',this.name)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/units/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.item){
              this.name = response.item.name
            }

          })
          .catch();
    },
    submit_delete(){
      if (!this.id_delete)return;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/units/destroy/${this.id_delete}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.message){
              toast.success(response.message)
              this.id_delete=''
              this.deleteModal=false
              this.all()
            }

          })
          .catch();
    },
    deleteMethod(id){
      this.id_delete = id
      this.deleteModal = true
    },
  },
  mounted() {
    this.all()
  }

}
</script>
<style scoped>

</style>